module.exports = __webpack_public_path__ + "img/gjyw.d219ab5b.png";